/* eslint-env browser */
/* eslint-disable no-alert, no-console */
/* global uk_msg */
// eslint-disable-next-line import/no-unresolved
require('bootstrap')
require('jquery-validation');

((window, $) => {
  const doc = window.document;
  const signUpModal = doc.getElementById('signup-modal');

  let loginModalIsLoading = false;
  let signupModalIsLoading = false;
  let createAccountModalIsLoading = false;
  let forgotPasswordModalIsLoading = false;

  const collectFormData = (form) => {
    const data = [];
    const { elements } = form;
    for (let i = 0, elementsCount = elements.length; i < elementsCount; i += 1) {
      const el = elements[i];
      data[i] = `${encodeURIComponent(el.name)}=${encodeURIComponent(el.value)}`;
    }
    return data.join('&');
  };

  class LoginForm {
    constructor(formId) {
      this.form = doc.getElementById(formId);
      this.loginModal = doc.getElementById('login-modal');
      this.createAccountModal = doc.getElementById('create-account-modal');
      this.signUpModal = doc.getElementById('signup-modal');

      if (!this.form) {
        throw new Error('Cannot find login form');
      }
      this.username = this.form.username;
      this.password = this.form.password;
      this.optTogglePassword = this.form.getElementsByClassName('password-visibility')[0]; // eslint-disable-line prefer-destructuring
    }

    initHandlers() {
      this.optTogglePassword.addEventListener('click', LoginForm.togglePassword.bind(this));

      if (this.loginModal.querySelector('.modal-body .btn-facebook-signup')) {
        this.loginModal.querySelector('.modal-body .btn-facebook-signup').addEventListener('click', LoginForm.showFacebookSignup.bind(this));
      }
      this.loginModal.querySelector('.modal-footer .open-create-account').addEventListener('click', this.showCreateAccountForm.bind(this));
      this.loginModal.querySelector('#open-forgot-password').addEventListener('click', this.showForgotPasswordForm.bind(this));
      if (this.loginModal.querySelector('.modal-body .btn-google-signup')) {
        this.loginModal.querySelector('.modal-body .btn-google-signup').addEventListener('click', LoginForm.showGoogleSignup.bind(this));
      }
    }

    submit(event) {
      event.stopPropagation();
      event.preventDefault();

      $.ajax({
        type: 'POST',
        url: '/admin/ajax',
        dataType: 'json',
        data: collectFormData(this.form),
        success: LoginForm.optOnSuccessLogin,
        error: LoginForm.onFailedLogin.bind(this),
      });
    }

    static showFacebookSignup() {
      $(this.loginModal).modal('hide');
    }

    static showGoogleSignup() {
      $(this.loginModal).modal('hide');
    }

    showCreateAccountForm(event) {
      event.preventDefault();
      event.stopPropagation();

      if( !createAccountModalIsLoading ){
          let promise = loadCreateAccountModalByAjax();
          promise.then(response => {
            this.createAccountModal = doc.getElementById('create-account-modal');
            this.loginModal = doc.getElementById('login-modal');

            $(this.loginModal).modal('hide')
              .on('hidden.bs.modal', () => {
                $(this.createAccountModal).modal('show');
                $(this.loginModal).unbind('hidden.bs.modal');
              })
          })

      }else{
        this.createAccountModal = doc.getElementById('create-account-modal');
        this.loginModal = doc.getElementById('login-modal');

        $(this.loginModal).modal('hide')
          .on('hidden.bs.modal', () => {
            $(this.createAccountModal).modal('show');
            $(this.loginModal).unbind('hidden.bs.modal');
          });
      }
    }

    showForgotPasswordForm(event) {
      event.preventDefault();
      event.stopPropagation();

      if( !forgotPasswordModalIsLoading ){
          let promise = loadForgotPasswordModalByAjax();
          promise.then(response => {
            this.forgotPasswordModal = doc.getElementById('forgot-password-modal');
            this.loginModal = doc.getElementById('login-modal');

             $(this.loginModal).modal('hide')
              .on('hidden.bs.modal', () => {
                $(this.forgotPasswordModal).modal('show');
                $(this.loginModal).unbind('hidden.bs.modal');
              });
          })

      } else {
        this.forgotPasswordModal = doc.getElementById('forgot-password-modal');
        this.loginModal = doc.getElementById('login-modal');

        $(this.loginModal).modal('hide')
          .on('hidden.bs.modal', () => {
            $(this.forgotPasswordModal).modal('show');
            $(this.loginModal).unbind('hidden.bs.modal');
          });
      }
    }

    static onFailedLogin(error) {
      console.log('Login failed: ', error, data); // eslint-disable-line no-undef
    }

    static optOnSuccessLogin(data) {
      // Success login
      if (data.code === 1) {
        window.location.reload();
      } else {
        // Something went wrong.
        /* @todo Show error messages here */
        uk_msg(data.msg);
      }
    }

    static togglePassword() {
      this.password.type = this.password.type === 'password' ? 'text' : 'password';
    }
  }

  class CreateAccountForm {
    constructor() {
      this.createAccountModal = doc.getElementById('create-account-modal');
      this.loginModal = doc.getElementById('login-modal');
      this.signUpModal = doc.getElementById('signup-modal');
    }

    init() {
      if (this.createAccountModal.querySelector('.modal-body .btn-facebook-signup')) {
        this.createAccountModal.querySelector('.modal-body .btn-facebook-signup').addEventListener('click', this.showFacebookSignup.bind(this));
      }

      if (this.createAccountModal.querySelector('.modal-body .btn-google-signup')) {
        this.createAccountModal.querySelector('.modal-body .btn-google-signup').addEventListener('click', CreateAccountForm.loginWithGoogle.bind(this));
      }

      this.createAccountModal.querySelector('.open-login').addEventListener('click', this.showLoginForm);
      this.createAccountModal.querySelector('.modal-body .btn-email-signup').addEventListener('click', this.showSignUpForm);
    }

    static loginWithGoogle() {
      window.location.replace('/store/googleLogin');
    }

    showLoginForm(event) {
      console.log('Showing login form')
      event.preventDefault();
      event.stopPropagation();

      if( !loginModalIsLoading ){
        let promise = loadLoginModalByAjax();
        promise.then(response => {
          this.loginModal = doc.getElementById('login-modal');
          this.createAccountModal = doc.getElementById('create-account-modal');

          $(this.createAccountModal).modal('hide')
            .on('hidden.bs.modal', () => {
              $(this.loginModal).modal('show');
              $(this.createAccountModal).unbind('hidden.bs.modal');
            });
        })

      } else {

        this.createAccountModal = doc.getElementById('create-account-modal');
        this.loginModal = doc.getElementById('login-modal');

        $(this.createAccountModal).modal('hide')
          .on('hidden.bs.modal', () => {
            $(this.loginModal).modal('show');
            $(this.createAccountModal).unbind('hidden.bs.modal');
          });

      }
    }

    showFacebookSignup() {
      $(this.createAccountModal).modal('hide');
    }

    showSignUpForm(event) {
      event.preventDefault();
      event.stopPropagation();

      if(!signupModalIsLoading){

        let promise = loadSignUpModalByAjax();
        promise.then(response => {
          this.signUpModal = doc.getElementById('signup-modal');
          this.createAccountModal = doc.getElementById('create-account-modal');

          $(this.createAccountModal).modal('hide')
            .on('hidden.bs.modal', () => {
              $(this.signUpModal).modal('show');
              $(this.createAccountModal).unbind('hidden.bs.modal');
            });
        })

      } else {
        this.signUpModal = doc.getElementById('signup-modal');
        this.createAccountModal = doc.getElementById('create-account-modal');
        $(this.createAccountModal).modal('hide')
          .on('hidden.bs.modal', () => {
            $(this.signUpModal).modal('show');
            $(this.createAccountModal).unbind('hidden.bs.modal');
          });
      }
    }

  }

  class SignUpForm {
    constructor(form) {
      this.signUpModal = doc.getElementById('signup-modal');
      this.loginModal = doc.getElementById('login-modal');
      this.createAccountModal = doc.getElementById('create-account-modal');

      this.currentForm = form;
      this.currentStep = 1;
      this.currentStepIndicators = doc.getElementById('signup-step-indicators');
      this.submitBtn = doc.getElementById('signup-submit');
      this.resendBtn = this.signUpModal.querySelector('.resend-link a');
      this.finishBtn = this.signUpModal.querySelector('.skip-and-finish-link a');

      this.currentAction = 'clientRegistration';
      this.clientId = null;
      this.password = this.currentForm.password;
      this.confirmPassword = this.currentForm.cpassword;
      this.optTogglePassword1 = this.currentForm.getElementsByClassName('password-visibility')[0]; // eslint-disable-line prefer-destructuring
      this.optTogglePassword2 = this.currentForm.getElementsByClassName('password-visibility')[1]; // eslint-disable-line prefer-destructuring
    }


    init() {
      this.signUpModal.querySelector('.modal-footer .open-login').addEventListener('click', this.showLoginForm);
      this.optTogglePassword1.addEventListener('click', SignUpForm.togglePassword.bind(null, this.password));
      this.optTogglePassword2.addEventListener('click', SignUpForm.togglePassword.bind(null, this.confirmPassword));

      this.resendBtn.addEventListener('click', this.resendVerificationCode.bind(this));
      this.finishBtn.addEventListener('click', this.finishRegistration.bind(this));
    }

    submit(event) {
      event.preventDefault();
      event.stopPropagation();

      let data = `${collectFormData(this.currentForm)}&action=${this.currentAction}`;
      if (this.currentStep === 2 && this.clientId) {
        data += `&client_id=${this.clientId}`;
      }
      let successHandler = this.onRegistrationSuccess.bind(this);

      switch (this.currentStep) {
        case 1: successHandler = this.onRegistrationSuccess.bind(this); break;
        case 2: successHandler = this.onVerificationSuccess.bind(this); break;
        case 3: successHandler = this.onEnterPromoCodeSuccess.bind(this); break;
        default: successHandler = this.onRegistrationSuccess.bind(this); break;
      }

      $.ajax({
        type: 'POST',
        url: '/admin/ajax',
        data,
        dataType: 'json',
        success: successHandler,
        error: SignUpForm.onRegistrationError.bind(this),
      });
    }

    resendVerificationCode(event) {
      event.preventDefault();
      event.stopPropagation();
      console.log('Client ID = ', this.clientId);
      $.ajax({
        url: '/admin/ajax',
        type: 'POST',
        dataType: 'json',
        data: {
          id: this.clientId,
          action: 'resendMobileCode',
        },
        success(data) {
          uk_msg(data.msg);
        },
      });
    }

    static togglePassword(passwordElement) {
      passwordElement.type = passwordElement.type === 'password' ? 'text' : 'password'; // eslint-disable-line no-param-reassign
    }


    showLoginForm(event) {
      event.preventDefault();
      event.stopPropagation();

      if( !loginModalIsLoading ){
        let promise = loadLoginModalByAjax();
        promise.then(response => {

          this.loginModal = doc.getElementById('login-modal');
          this.signUpModal = doc.getElementById('signup-modal');

          $(this.signUpModal).modal('hide')
              .on('hidden.bs.modal', () => {
                $(this.loginModal).modal('show');
                $(this.signUpModal).unbind('hidden.bs.modal');
              });
        })

      } else {
        this.loginModal = doc.getElementById('login-modal');
        this.signUpModal = doc.getElementById('signup-modal');

        $(this.signUpModal).modal('hide')
          .on('hidden.bs.modal', () => {
            $(this.loginModal).modal('show');
            $(this.signUpModal).unbind('hidden.bs.modal');
          });

      }
    }

    finishRegistration(event) {
      event.preventDefault();
      event.stopPropagation();

      this.signUpModal = doc.getElementById('signup-modal');

      $(this.signUpModal).modal('hide')
        .on('hidden.bs.modal', () => {
          window.location.reload();
        });
    }

    onRegistrationSuccess(data) {

      if (data.code === 1 || data.code === 3) {
        this.signUpModal.querySelector('h5').innerText = 'Almost done';
        this.signUpModal.querySelector('.verification-text').classList.remove('d-none');
        this.signUpModal.querySelector(`.form-step-${this.currentStep}`).remove();
        this.currentStepIndicators.querySelector(`.step-${this.currentStep}`).classList.remove('active');
        this.currentStep += 1;
        this.signUpModal.querySelector(`.form-step-${this.currentStep}`).classList.add('active');
        this.signUpModal.querySelector(`.step-${this.currentStep}`).classList.add('active');
        this.submitBtn.innerText = (data.code === 1 ? 'Next' : 'Finish');
        this.signUpModal.querySelector('.resend-link').classList.remove('d-none');
        this.currentAction = 'verifyMobileCode';
        this.clientId = data.details;
      } else if (this.currentAction === 'clientRegistration') {
        uk_msg(data.msg);
      } else {
        uk_msg(data.msg);
      }
    }

    onVerificationSuccess(data) {
      if (data.code === 1) {
        this.signUpModal.querySelector('h5').innerText = 'Have a promo code?';
        this.signUpModal.querySelector('.verification-text').classList.add('d-none');
        this.signUpModal.querySelector('.promocode-text').classList.remove('d-none');
        this.signUpModal.querySelector(`.form-step-${this.currentStep}`).remove();
        this.currentStepIndicators.querySelector(`.step-${this.currentStep}`).classList.remove('active');
        this.currentStep += 1;
        this.signUpModal.querySelector(`.form-step-${this.currentStep}`).classList.add('active');
        this.signUpModal.querySelector(`.step-${this.currentStep}`).classList.add('active');
        this.submitBtn.innerText = 'Apply code';
        this.signUpModal.querySelector('.resend-link').classList.add('d-none');
        this.signUpModal.querySelector('.skip-and-finish-link').classList.remove('d-none');
        this.currentAction = 'setPromoCode';
        this.clientId = data.details;
      } else if (data.code === 3) {
        window.location.reload();
      } else {
        uk_msg(data.msg);
      }
    }

    onEnterPromoCodeSuccess(data) { // eslint-disable-line class-methods-use-this
      if (data.code === 1) {
        window.location.reload();
      } else {
        uk_msg(data.msg);
      }
    }

    static onRegistrationError() {

    }
  }


  class ForgotPasswordStepOneForm {
    constructor(form) {
      this.currentForm = form;
      this.currentAction = 'forgotPassword';
      this.backBtn = document.getElementById('back-to-login-btn');
      this.loginModal = document.getElementById('login-modal');
      this.forgotPasswordModal = doc.getElementById('forgot-password-modal');
    }

    init() {
      this.backBtn.addEventListener('click', this.backToLogin.bind(this));
    }

    submit(event) {
      event.stopPropagation();
      event.preventDefault();

      const data = `${collectFormData(this.currentForm)}&action=${this.currentAction}`;

      $.ajax({
        type: 'POST',
        url: '/admin/ajax',
        dataType: 'json',
        data,
        success:  this.optOnSuccess.bind(this),
        error: ForgotPasswordStepOneForm.optOnError.bind(this),
      });
    }

    backToLogin(event) {
      event.preventDefault();
      event.stopPropagation();

      $(this.forgotPasswordModal).modal('hide')
        .on('hidden.bs.modal', () => {
          $(this.loginModal).modal('show');
          $(this.forgotPasswordModal).unbind('hidden.bs.modal');
        });
    }

    optOnSuccess(data) {
      alert(data.msg); // eslint-disable-line no-alert
      if (data.code === 1) {
        $(this.forgotPasswordModal).modal('hide');
      }
    }

    static optOnError() {
      alert('Something went wrong. Please try again');
    }
  }

  class ForgotPasswordStepTwoForm {
    constructor(form) {
      this.currentForm = form;
      this.currentAction = 'changePassword';
      this.newPassword = this.currentForm.password;
      this.confirmPassword = this.currentForm.confirm_password;
      this.toggleNewPasswordEl = this.currentForm.getElementsByClassName('toggle-password-visibility')[0]; // eslint-disable-line prefer-destructuring
      this.toggleConfirmPasswordEl = this.currentForm.getElementsByClassName('toggle-password-visibility')[1]; // eslint-disable-line prefer-destructuring
    }

    init() {
      this.toggleNewPasswordEl.addEventListener('click', ForgotPasswordStepTwoForm.optTogglePassword.bind(null, this.newPassword));
      this.toggleConfirmPasswordEl.addEventListener('click', ForgotPasswordStepTwoForm.optTogglePassword.bind(null, this.confirmPassword));
    }

    submit(event) {
      event.preventDefault();
      event.stopPropagation();

      const currQueryParams = window.location.href.split('?')[1];
      const data = `${collectFormData(this.currentForm)}&action=${this.currentAction}&${currQueryParams}`;

      $.ajax({
        type: 'POST',
        url: '/admin/ajax',
        dataType: 'json',
        data,
        success: ForgotPasswordStepTwoForm.optOnSuccess.bind(this),
        error: ForgotPasswordStepTwoForm.optOnError.bind(this),
      });
    }

    static optTogglePassword(passwordElement) {
      passwordElement.type = passwordElement.type === 'password' ? 'text' : 'password'; // eslint-disable-line no-param-reassign
    }

    static optOnSuccess(data) {
      alert(data.msg);
      if (data.code === 1) {
        window.location.href = window.location.pathname; // eslint-disable-line no-param-reassign
      }
    }

    static optOnError() {
      alert('Something went wrong. Please try again');
    }
  }


  $(doc).on('click', '#login-modal-btn,#login-modal-btn-footer', function showLoginModal() {
    if(!loginModalIsLoading){
      loadLoginModalByAjax(true);
    }else{
      $('#login-modal').modal('show');
    }
    return false;
  });


  $(doc).on('click', '#create-account-btn,#create-account-btn-footer', function showSignUpFormModal() {
    if(!createAccountModalIsLoading){
      loadCreateAccountModalByAjax(true);
    }else{
      $('#create-account-modal').modal('show');
    }
    return false;
  });

  function loadLoginModalByAjax(show=false) {
    return new Promise(function(resolve, reject) {
      $.ajax({
        type: 'GET',
        url: '/store/getLoginForm',
        dataType: 'html',
        success (data) {
          $('div#modal_login_div').html(data);
          loginModalIsLoading = true;

          const loginForm = new LoginForm('login-form');
          loginForm.initHandlers();

          $('#login-form').validate({
            rules: {
              username: {
                required: true,
                email: true,
              },
              password: {
                required: true,
                minlength: 4,
              },
            },
            messages: {
              username: {
                required: 'Please enter your email',
                email: 'Please enter a valid email',
              },
              password: {
                required: 'Please enter your password',
                minlength: 'Your password must be at least 4 characters long',
              },
            },

            submitHandler(form, event) {
              loginForm.submit(event);
            },
          });


          if(show){
            $('#login-modal').modal('show');
          }
          resolve(true);
        },
        error (error) {
          console.log('Error: ', error);
        }
      });
    });
  }

  function loadSignUpModalByAjax(show=false) {
     return new Promise(function(resolve, reject) {
        $.ajax({
          type: 'GET',
          url: '/store/getSignUpForm',
          dataType: 'html',
          success (data) {
            $('div#modal_signup_div').html(data);
            signupModalIsLoading = true;

            const signUpForm = new SignUpForm(document.getElementById('signup-form'));
            signUpForm.init();

            $('#signup-form').validate({
              errorClass: 'validation-error',
              rules: {
                first_name: {
                  required: true,
                },
                last_name: {
                  required: true,
                },
                email_address: {
                  required: true,
                  email: true,
                },
                password: {
                  required: true,
                  minlength: 4,
                },
                cpassword: {
                  required: true,
                  equalTo: '#signup-email_password',
                },
                contact_phone: {
                  required: true,
                  checkPhone: true,
                },
                code: {
                  required: true,
                },
                promocode: {
                  required: true,
                },
              },
              messages: {
                first_name: {
                  required: 'Please enter your name',
                },
                last_name: {
                  required: 'Please enter your last name',
                },
                email_address: {
                  required: 'Please enter your email',
                  email: 'Please enter a valid email',
                },
                password: {
                  required: 'Please enter your password',
                  minlength: 'Your password must be at least 4 characters long',
                },
                cpassword: {
                  required: 'Please re-enter your password',
                  equalTo: 'The value should be the same as previous field',
                },
                contact_phone: {
                  required: 'Please enter your phone number',
                  phoneUS: 'Please enter valid phone number',
                },
                code: {
                  required: 'Please enter verification code',
                },
                promocode: {
                  required: 'Please enter promo code or click finish link',
                },
              },
              submitHandler(form, event) {
                signUpForm.submit(event);
              },
            });

            if(show){
              $('#signup-modal').modal('show');
            }
            resolve(true);
          },
          error (error) {
            console.log('Error: ', error);
          }
        });
    });
  }

  function loadCreateAccountModalByAjax(show=false) {
    return new Promise(function(resolve, reject) {
        $.ajax({
          type: 'GET',
          url: '/store/getCreateAccountForm',
          dataType: 'html',
          success (data) {
            $('div#modal_create_account_div').html(data);

            createAccountModalIsLoading = true;
            const createAccountForm = new CreateAccountForm('create-account-form');
            createAccountForm.init();

            if(show){
              $('#create-account-modal').modal('show');
            }
            resolve(true);
          },
          error (error) {
            console.log('Error: ', error);
          }
        });
    });
  }

  function loadForgotPasswordModalByAjax(show=false) {
    return new Promise(function(resolve, reject) {
        $.ajax({
          type: 'GET',
          url: '/store/getForgotPasswordForm',
          dataType: 'html',
          success (data) {
            $('div#modal_forgot_password_div').html(data);

            forgotPasswordModalIsLoading = true;

            const forgotPasswordStepOneFormEl = document.querySelector('#forgot-password-modal form');
            if (forgotPasswordStepOneFormEl) {
              const forgotPasswordForm = new ForgotPasswordStepOneForm(forgotPasswordStepOneFormEl);
              forgotPasswordForm.init();

              $(forgotPasswordStepOneFormEl).validate({
                errorClass: 'validation-error',
                rules: {
                  'username-email': {
                    required: true,
                    email: true,
                  },
                },
                messages: {
                  'username-email': {
                    required: 'Please enter your email',
                    email: 'Please enter a valid email',
                  },
                },
                submitHandler(form, event) {
                  forgotPasswordForm.submit(event);
                },
              });
            }

            if(show){
              $('#forgot-password-modal').modal('show');
            }
            resolve(true);
          },
          error (error) {
            console.log('Error: ', error);
          }
        });
    });
  }


  const forgotPasswordStepTwoFormEl = document.querySelector('#reset-password-modal form');
  if (forgotPasswordStepTwoFormEl) {
    const forgotPasswordForm = new ForgotPasswordStepTwoForm(forgotPasswordStepTwoFormEl);
    forgotPasswordForm.init();

    $(forgotPasswordStepTwoFormEl).validate({
      errorClass: 'validation-error',
      rules: {
        password: {
          required: true,
          minlength: 4,
        },
        confirm_password: {
          required: true,
          equalTo: '#forgot-new-password',
        },
      },
      messages: {
        password: {
          required: 'Please enter your password',
          minlength: 'Your password must be at least 4 characters long',
        },
        confirm_password: {
          required: 'Please re-enter your password',
          equalTo: 'The value should be the same as previous field',
        },
      },
      submitHandler(form, event) {
        forgotPasswordForm.submit(event);
      },
    });
  }

  $().ready(() => {

    if (window.location.href.indexOf('isResetPassword=1') > -1) {
      loadForgotPasswordModalByAjax(true);
      forgotPasswordModal = doc.getElementById('forgot-password-modal');

      const prevStep = forgotPasswordModal.getElementsByClassName('form-step-1')[0];
      prevStep.classList.remove('active');

      const nextStep = forgotPasswordModal.getElementsByClassName('form-step-2')[0];
      nextStep.classList.add('active');
    }
  });
})(window, window.jQuery);
